import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/Praveen Kumar Logo.png';

const THEME_KEY = 'portfolio_theme';
const THEME_VERSION_KEY = 'portfolio_theme_version';
const CURRENT_THEME_VERSION = 'v1_dark_default';

const applyThemeToDOM = (isDark) => {
  if (isDark) {
    document.body.classList.add('dark-theme');
    document.body.setAttribute('data-theme', 'dark');
    document.documentElement.classList.add('dark-theme');
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.body.classList.remove('dark-theme');
    document.body.setAttribute('data-theme', 'light');
    document.documentElement.classList.remove('dark-theme');
    document.documentElement.setAttribute('data-theme', 'light');
  }
};

const getInitialDarkMode = () => {
  try {
    // Override previously saved Light Mode preferences once during rollout
    if (localStorage.getItem(THEME_VERSION_KEY) !== CURRENT_THEME_VERSION) {
      localStorage.setItem(THEME_VERSION_KEY, CURRENT_THEME_VERSION);
      localStorage.setItem(THEME_KEY, 'dark');
      try {
        localStorage.removeItem('theme');
        localStorage.removeItem('darkMode');
      } catch (e) {}
      applyThemeToDOM(true);
      return true;
    }

    const saved = localStorage.getItem(THEME_KEY);
    // Dark Mode is the default for every visitor unless explicitly saved as 'light'
    const isDark = saved !== 'light';
    applyThemeToDOM(isDark);
    return isDark;
  } catch (e) {
    applyThemeToDOM(true);
    return true; // Fallback to Dark Mode
  }
};

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(getInitialDarkMode);

  useEffect(() => {
    applyThemeToDOM(darkMode);
  }, [darkMode]);

  // Synchronize theme changes across open tabs/windows
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === THEME_KEY) {
        const isDark = e.newValue !== 'light';
        setDarkMode(isDark);
        applyThemeToDOM(isDark);
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // NEW
  const closeMenu = () => {
    setMenuOpen(false);
  };

  const toggleDarkMode = () => {
    const nextMode = !darkMode;
    setDarkMode(nextMode);
    applyThemeToDOM(nextMode);
    try {
      localStorage.setItem(THEME_KEY, nextMode ? 'dark' : 'light');
    } catch (e) {}
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">

        {/* Logo + Name Click → Home */}
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src={logo} alt="Logo" />
          <span className="logo-text">Praveen Kumar B</span>
        </Link>

      </div>

      <div className="navbar-right">
        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={closeMenu}>Home</Link>
          <Link to="/about" onClick={closeMenu}>About</Link>
          <Link to="/projects" onClick={closeMenu}>Projects</Link>
          <Link to="/internships" onClick={closeMenu}>Internships</Link>
          <Link to="/certificates" onClick={closeMenu}>Certificates</Link>
          <Link to="/skills" onClick={closeMenu}>Skills</Link>
          <Link to="/my-activity" onClick={closeMenu}>My Activity</Link>
          <Link to="/resume" onClick={closeMenu}>Resume</Link>
          <Link to="/book-session" onClick={closeMenu}>Book A Session</Link>
          <Link to="/events" onClick={closeMenu}>Events</Link>
          <Link to="/blogs" onClick={closeMenu}>Blogs</Link>
          <Link to="/contact" onClick={closeMenu}>Contact</Link>
        </div>

        <div className="navbar-icons">
          <button className="dark-mode-toggle" onClick={toggleDarkMode}>
            {darkMode ? '🌙' : '🌞'}
          </button>

          <div className="menu-icon" onClick={toggleMenu}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
